import { TranslationString } from '../localization';
import {
  ProjectSettingsTypes,
  ProjectEnableForSetting
} from '../projectSettingsTypes';

import {
  BusinessHoursErrorCode,
  BusinessHoursSettingsServer
} from './businessHours/server';

export type ModeProjectServer = {
  enabled: boolean;
  in: ProjectSettingsTypes;
};

export type EnabledProjectSettingServer = {
  enabled: boolean;
  for: ProjectEnableForSetting;
};

export enum EventsQueueMode {
  project = 'project',
  user = 'user'
}

export type UserVars = {
  email: string | null;
  phone: string | null;
};

export enum UserCardVarErrorCode {
  userCardVarNotFound = 'user_card_var_not_found',
  invalidVarKey = 'invalid_var_key'
}

export const mapUserCardVarErrorToMessage = (
  code: UserCardVarErrorCode
): TranslationString => {
  switch (code) {
    case UserCardVarErrorCode.userCardVarNotFound:
      return (t) =>
        t('SettingsStore.notifications.userCardVarNotFound', {
          ns: 'stores'
        });
    case UserCardVarErrorCode.invalidVarKey:
      return (t) =>
        t('SettingsStore.notifications.userCardInvalidVarKey', {
          ns: 'stores'
        });
  }
};

export type CsatSettingsServer = {
  enabled: boolean;
  prompt_text: string;
  ask_comment: boolean;
};

export type ProjectSettingsServer = {
  debug_mode: ModeProjectServer;
  use_unpublished: ModeProjectServer;
  bot_enabled: EnabledProjectSettingServer;
  like_threshold: number;
  timezone: string;
  events_queue_lock_mode: EventsQueueMode;
  //в минутах
  unstop_by_manager_delay: number;
  user_vars: UserVars;
  csat: CsatSettingsServer;
  conversation_auto_close_delay_minutes: number | null;
  business_hours?: BusinessHoursSettingsServer | null;
  business_hours_error?: BusinessHoursErrorCode | null;
};
